import { AxiosError } from 'axios';

import {
  SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_FAILURE,
  SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_REQUEST,
  SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_SUCCESS,
} from '@app/store/actionTypes';

export const fetchSigningRequestCount = () => {
  return {
    type: SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_REQUEST,
  };
};

export const fetchSigningRequestCountSuccess = (countOfDocuments: number) => {
  return {
    type: SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_SUCCESS,
    payload: countOfDocuments,
  };
};

export const fetchSigningRequestCountFailure = (error: AxiosError) => {
  return {
    type: SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_FAILURE,
    payload: error,
    error: true,
  };
};

export type SoftLandingAction =
  | ReturnType<typeof fetchSigningRequestCount>
  | ReturnType<typeof fetchSigningRequestCountSuccess>
  | ReturnType<typeof fetchSigningRequestCountFailure>;
